"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
const baseStyle = {
  button: {
    px: 8,
    py: 3,
    fontSize: 'base',
    fontFamily: 'body',
    lineHeight: 0.875,
    fontWeight: 'semibold',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'base',
    textTransform: 'capitalize',
    transition: 'all normal ease',
    _hover: {
      bg: 'gray.50',
      borderColor: 'gray.200'
    },
    _disabled: {
      cursor: 'not-allowed',
      opacity: 1,
      bg: 'gray.200',
      borderColor: 'gray.200',
      color: 'gray.600'
    },
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  list: {
    bg: 'white',
    boxShadow: 'base',
    padding: 6,
    zIndex: 'layer1',
    width: 64
  },
  item: {
    paddingX: 2,
    paddingY: 1.5,
    _focus: {
      zIndex: 1,
      boxShadow: 'outline'
    }
  },
  groupTitle: {
    fontWeight: 'semibold',
    color: 'gray.600',
    padding: 2
  },
  command: {
    // this will style the text defined by the command
    // prop in the MenuItem and MenuItemOption components
    opacity: '0.8',
    fontFamily: 'mono',
    fontSize: 'sm',
    letterSpacing: 'tighter',
    paddingL: 4
  },
  divider: {
    marginY: 2,
    borderColor: 'gray.200'
  }
};
const variants = {
  basic: {
    button: {
      bg: 'primary.default',
      borderColor: 'primary.default',
      color: 'white',
      _hover: {
        bg: 'primary.600',
        borderColor: 'primary.600',
        color: 'white',
        _disabled: {
          bg: 'gray.200',
          borderColor: 'gray.200',
          color: 'gray.600'
        }
      }
    },
    list: {
      bg: 'white',
      boxShadow: 'base',
      zIndex: 'layer1',
      borderColor: 'gray.100',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderRadius: 'base',
      padding: 4,
      width: 64
    },
    groupTitle: {
      fontWeight: 'semibold',
      fontSize: 'md',
      color: 'gray.600',
      padding: 2
    },
    item: {
      fontWeight: 'semibold',
      _hover: {
        color: 'gray.600'
      }
    }
  },
  full: {
    button: {
      height: 8,
      fontSize: 'sm',
      fontWeight: 'semibold',
      color: 'black',
      borderColor: 'white',
      backgroundColor: 'white',
      borderRadius: 'base',
      paddingX: 3,
      paddingY: 'auto',
      _hover: {
        color: 'black',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50'
      },
      _active: {
        color: 'primary.default',
        backgroundColor: 'gray.50',
        borderColor: 'gray.50',
        _hover: {
          color: 'primary.600',
          backgroundColor: 'gray.50',
          borderColor: 'gray.50'
        }
      }
    },
    list: {
      height: '30rem',
      width: '100vw',
      padding: 8,
      backgroundColor: 'white'
    },
    groupTitle: {
      fontSize: 'sm',
      weight: 'normal',
      color: 'gray.600'
    },
    item: {
      display: 'block',
      paddingX: 3.5,
      paddingY: 2.5,
      marginBottom: 2,
      _last: {
        marginBottom: 0
      },
      _hover: {
        backgroundColor: 'gray.50'
      },
      _focus: {
        boxShadow: 'none',
        backgroundColor: 'gray.50'
      }
    }
  }
};
var _default = exports.default = (0, _merge.default)(_theme.default.components.Menu, {
  baseStyle,
  variants
});